import { jwtDecode } from "jwt-decode";

export const getUserFromToken = (token: string) => {
  if (token) {
    const decoded: any = jwtDecode(token);
    return decoded?.user ?? null;
  } else {
    return null;
  }
};
